import * as actions from '../../actions/hostelWorldActions'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch } from '../apiUtils'
import * as urls from '../urls'

/**
 * @param {Object} params - List of path params
 * @param {number[]} params.organizationIds - Organization Ids
 */
export const hwPushYearPrices = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.hw_pushYearPricesRequest())

    securedFetch(urlParams(urls.hwPushYearPrices, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(() => dispatch(actions.hw_pushYearPricesSuccess()))
        .catch(
            handleError(
                dispatch,
                actions.hw_pushYearPricesFailure,
                'Что-то пошло не так!',
                'При отправке цен в HostelWorld.com произошла ошибка'
            )
        )
}

/**
 * @param {Object} params - List of path params
 * @param {number} params.organizationIds - Organization Ids
 */
export const hwCheckAndPullOrders = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.hw_checkAndPullOrdersRequest())

    securedFetch(urlParams(urls.hwCheckAndPullOrders, params), auth, { method: 'POST' })
        .then(handleResponse)
        .then(() => dispatch(actions.hw_checkAndPullOrdersSuccess()))
        .catch(
            handleError(
                dispatch,
                actions.hw_checkAndPullOrdersFailure,
                'Что-то пошло не так!',
                'При проверке заказов в HostelWorld.com произошла ошибка'
            )
        )
}

/**
 * @param {Object} params - List of path params
 * @param {number[]} params.organizationIds - Organization Ids
 */
export const hwInventoryAvailability = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.hw_inventoryAvailabilityRequest())

    securedFetch(urlParams(urls.hwInventoryAvailability, params), auth, { method: 'POST' })
        .then(handleResponse)
        .then(() => dispatch(actions.hw_inventoryAvailabilitySuccess()))
        .catch(
            handleError(
                dispatch,
                actions.hw_inventoryAvailabilityFailure,
                'Что-то пошло не так!',
                'При попытке inventory доступности в HostelWorld.com произошла ошибка'
            )
        )
}


// WEBPACK FOOTER //
// ./src/api/hostelWorldApi/hwSync.js